var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Input as ThemeUIInput, } from 'theme-ui';
export const defaultInputStyles = {
    height: '50px',
    border: 1,
    borderRadius: 0,
    borderStyle: 'solid',
    borderColor: 'neutralBorder',
    margin: 0,
    paddingX: 'm',
    paddingY: 's',
    backgroundColor: 'neutralBg',
    '&:focus': {
        borderColor: 'baseBorder',
        caretColor: 'baseText',
    },
    '::placeholder': {
        opacity: 1,
        color: 'neutralTextWeak',
    },
    ':disabled': {
        color: 'neutralTextDisabled',
        borderColor: 'neutralBorderWeakDisabled',
    },
    ':disabled::placeholder': {
        opacity: 1,
        color: 'neutralTextDisabled',
    },
    // to remove the sidebar with arrows when input is [type=number]
    /* Chrome, Safari, Edge, Opera */
    '::-webkit-outer-spin-button, ::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
    },
    /* Firefox */
    '&[type=number]': {
        MozAppearance: 'textfield',
    },
};
const ChocoInput = forwardRef((_a, ref) => {
    var { children, sx, hasError = false } = _a, props = __rest(_a, ["children", "sx", "hasError"]);
    const borderColorOverride = hasError
        ? { borderColor: 'dangerBorder' }
        : {};
    return (_jsx(ThemeUIInput, Object.assign({ ref: ref, sx: Object.assign(Object.assign(Object.assign({}, defaultInputStyles), sx), borderColorOverride) }, props, { children: children })));
});
export default ChocoInput;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hvY29JbnB1dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NvbW1vbnMvQ2hvY29Gb3JtL0Nob2NvSW5wdXQvQ2hvY29JbnB1dC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFVBQVUsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUNuQyxPQUFPLEVBRUwsS0FBSyxJQUFJLFlBQVksR0FHdEIsTUFBTSxVQUFVLENBQUM7QUFJbEIsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQXVCO0lBQ3BELE1BQU0sRUFBRSxNQUFNO0lBQ2QsTUFBTSxFQUFFLENBQUM7SUFDVCxZQUFZLEVBQUUsQ0FBQztJQUNmLFdBQVcsRUFBRSxPQUFPO0lBQ3BCLFdBQVcsRUFBRSxlQUFlO0lBQzVCLE1BQU0sRUFBRSxDQUFDO0lBQ1QsUUFBUSxFQUFFLEdBQUc7SUFDYixRQUFRLEVBQUUsR0FBRztJQUNiLGVBQWUsRUFBRSxXQUFXO0lBQzVCLFNBQVMsRUFBRTtRQUNULFdBQVcsRUFBRSxZQUFZO1FBQ3pCLFVBQVUsRUFBRSxVQUFVO0tBQ3ZCO0lBQ0QsZUFBZSxFQUFFO1FBQ2YsT0FBTyxFQUFFLENBQUM7UUFDVixLQUFLLEVBQUUsaUJBQWlCO0tBQ3pCO0lBQ0QsV0FBVyxFQUFFO1FBQ1gsS0FBSyxFQUFFLHFCQUFxQjtRQUM1QixXQUFXLEVBQUUsMkJBQTJCO0tBQ3pDO0lBQ0Qsd0JBQXdCLEVBQUU7UUFDeEIsT0FBTyxFQUFFLENBQUM7UUFDVixLQUFLLEVBQUUscUJBQXFCO0tBQzdCO0lBRUQsZ0VBQWdFO0lBQ2hFLGlDQUFpQztJQUNqQywwREFBMEQsRUFBRTtRQUMxRCxnQkFBZ0IsRUFBRSxNQUFNO0tBQ3pCO0lBRUQsYUFBYTtJQUNiLGdCQUFnQixFQUFFO1FBQ2hCLGFBQWEsRUFBRSxXQUFXO0tBQzNCO0NBQ0YsQ0FBQztBQU1GLE1BQU0sVUFBVSxHQUFrRCxVQUFVLENBQzFFLENBQUMsRUFBNEMsRUFBRSxHQUFHLEVBQUUsRUFBRTtRQUFyRCxFQUFFLFFBQVEsRUFBRSxFQUFFLEVBQUUsUUFBUSxHQUFHLEtBQUssT0FBWSxFQUFQLEtBQUssY0FBMUMsOEJBQTRDLENBQUY7SUFDekMsTUFBTSxtQkFBbUIsR0FBcUIsUUFBUTtRQUNwRCxDQUFDLENBQUMsRUFBRSxXQUFXLEVBQUUsY0FBYyxFQUFFO1FBQ2pDLENBQUMsQ0FBQyxFQUFFLENBQUM7SUFFUCxPQUFPLENBQ0wsS0FBQyxZQUFZLGtCQUNYLEdBQUcsRUFBRSxHQUFHLEVBQ1IsRUFBRSxnREFDRyxrQkFBa0IsR0FDbEIsRUFBRSxHQUNGLG1CQUFtQixLQUVwQixLQUFLLGNBRVIsUUFBUSxJQUNJLENBQ2hCLENBQUM7QUFDSixDQUFDLENBQ0YsQ0FBQztBQUVGLGVBQWUsVUFBVSxDQUFDIn0=